
import ListProjects from './components/list';
export default function Projects() {
    return <ListProjects />
}

